import { lazy } from "react";

const SupplierProfile = lazy(() => import("@pages/supplier/SupplierProfile"));
const SupplierPerformance = lazy(
  () => import("@pages/supplier/SupplierPerformance"),
);
const AssessmentTemplateLayout = lazy(
  () => import("@pages/supplier/AssessmentTemplate/Layout"),
);
const AdmissionAssessmentTemplate = lazy(
  () =>
    import(
      "@pages/supplier/AssessmentTemplate/components/AdmissionAssessmentTemplate"
    ),
);
const PerformanceAssessmentTemplate = lazy(
  () =>
    import(
      "@pages/supplier/AssessmentTemplate/components/PerformanceAssessmentTemplate"
    ),
);
const AppPerformanceAssessmentTemplate = lazy(
  () =>
    import(
      "@pages/supplier/AssessmentTemplate/components/PerformanceAssessmentTemplate/Edit"
    ),
);
const AddAdmissionAssessmentTemplate = lazy(
  () =>
    import(
      "@pages/supplier/AssessmentTemplate/components/AdmissionAssessmentTemplate/Edit"
    ),
);
const EmailInvite = lazy(
  () =>
    import(
      "@/pages/supplier/SupplierProfile/components/RegisteredTab/EmailInvite"
    ),
);

const ArchiveDetail = lazy(
  () =>
    import(
      /* webpackChunkName: "ArchiveDetail" */
      "@pages/supplier/SupplierProfile/archiveDetail"
    ),
);

const SupplierExceptionLayout = lazy(
  () => import("@pages/supplier/SupplierException/Layout"),
);

const SupplierRiskLevel = lazy(
  () => import("@pages/supplier/SupplierException/SupplierRiskLevel"),
);

const MaterialExceptionLevel = lazy(
  () => import("@pages/supplier/SupplierException/MaterialExceptionLevel"),
);

const SupplierVisitAndAuditLayout = lazy(
  () => import("@pages/supplier/SupplierVisitAndAudit/Layout"),
);

const VisitManagement = lazy(
  () => import("@pages/supplier/SupplierVisitAndAudit/VisitManagement"),
);

const AuditManagement = lazy(
  () => import("@pages/supplier/SupplierVisitAndAudit/AuditManagement"),
);

const supplierRoute: RouteConfig[] = [
  {
    path: "/supplier",
    name: "supplier",
    crumbTitle: "供应商管理", // 中文标题给面包屑
    component: SupplierProfile, // 默认显示档案页
    children: [
      {
        path: "/supplier/profile",
        name: "profile",
        crumbTitle: "供应商档案管理",
        component: SupplierProfile,
        children: [
          {
            path: "/supplier/profile/email-invite",
            name: "emailInvite",
            crumbTitle: "邮箱邀请",
            component: EmailInvite,
          },
          {
            path: "/supplier/profile/archive-detail",
            name: "archiveDetail",
            crumbTitle: "供应商档案详情",
            component: ArchiveDetail,
          },
        ],
      },
      {
        path: "/supplier/performance",
        name: "performance",
        crumbTitle: "供应商绩效管理",
        component: SupplierPerformance,
      },
      {
        path: "/supplier/assessment-template",
        name: "assessmentTemplate",
        crumbTitle: "评估模板管理",
        component: AssessmentTemplateLayout,
        children: [
          {
            path: "/supplier/assessment-template/admission",
            name: "admissionAssessmentTemplate",
            crumbTitle: "准入评估模板",
            component: AdmissionAssessmentTemplate,
          },
          {
            path: "/supplier/assessment-template/admission/edit",
            name: "addAdmissionAssessmentTemplate",
            crumbTitle: "添加模板",
            component: AddAdmissionAssessmentTemplate,
          },
          {
            path: "/supplier/assessment-template/performance",
            name: "performanceAssessmentTemplate",
            crumbTitle: "绩效考核模板",
            component: PerformanceAssessmentTemplate,
          },
          {
            path: "/supplier/assessment-template/performance/edit",
            name: "addPerformanceAssessmentTemplate",
            crumbTitle: "添加模板",
            component: AppPerformanceAssessmentTemplate,
          },
        ],
      },
      {
        path: "/supplier/exception",
        name: "exception",
        crumbTitle: "供应商异常管理",
        component: SupplierExceptionLayout,
        children: [
          {
            path: "/supplier/exception/risk-level",
            name: "riskLevel",
            crumbTitle: "供应商风险登记",
            component: SupplierRiskLevel,
          },
          {
            path: "/supplier/exception/material-exception-level",
            name: "materialExceptionLevel",
            crumbTitle: "物料异常登记",
            component: MaterialExceptionLevel,
          },
        ],
      },
      {
        path: "/supplier/visit-and-audit",
        name: "visitAndAudit",
        crumbTitle: "供应商拜访与审计管理",
        component: SupplierVisitAndAuditLayout,
        children: [
          {
            path: "/supplier/visit-and-audit/visit",
            name: "visit",
            crumbTitle: "拜访管理",
            component: VisitManagement,
          },
          {
            path: "/supplier/visit-and-audit/audit",
            name: "audit",
            crumbTitle: "审计管理",
            component: AuditManagement,
          },
        ],
      },
    ],
  },
];

export default supplierRoute;
